import { useBrand } from '../lib/brand';
import { WAVE_NAVY, WAVE_NAVY_HEX, WAVE_TEAL, WAVE_TEAL_HEX, WAVE_VIEWBOX } from './waveMark';

export function WaveIcon({
  tone = 'ink',
  className = '',
}: {
  tone?: 'ink' | 'light';
  className?: string;
}) {
  const body = tone === 'light' ? '#FFFFFF' : WAVE_NAVY_HEX;
  return (
    <svg viewBox={WAVE_VIEWBOX} className={className} aria-hidden>
      <path fill={body} d={WAVE_NAVY} />
      <path fill={WAVE_TEAL_HEX} d={WAVE_TEAL} />
    </svg>
  );
}

export function Wordmark({
  tone = 'ink',
  variant = 'compact',
  className = '',
}: {
  tone?: 'ink' | 'light';
  variant?: 'compact' | 'full';
  className?: string;
}) {
  const brand = useBrand();
  const src = tone === 'light' ? '/brand/marshal/logo-on-dark.png' : '/brand/marshal/logo.png';
  if (variant === 'full') {
    return (
      <img
        src={src}
        alt={`${brand.name} for swim clubs`}
        className={`h-40 w-40 rounded-3xl ${className}`}
      />
    );
  }
  const ink = tone === 'light' ? 'text-white' : 'text-[#1d1d1f]';
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <img src={src} alt="" className="h-11 w-11 rounded-xl" />
      <span className={`text-[17px] font-semibold tracking-tight ${ink}`}>{brand.name}</span>
    </span>
  );
}
